
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Drupal ou WordPress : quel est le meilleur CMS pour vous ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "WordPress vs Drupal - Nous discutons ici des avantages, des bénéfices et de la question de savoir si Drupal ou WordPress est la meilleure solution pour vous.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Drupal ou WordPress : quel est le meilleur CMS pour vous ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "WordPress vs Drupal - Nous discutons ici des avantages, des bénéfices et de la question de savoir si Drupal ou WordPress est la meilleure solution pour vous.",
        },
      ],
    };
  },
};
